import api from '../../api';
import {
	BiReportType,
	BiTokenContext,
} from '../../variables/external/biExplorer';

export interface BiTokenResponse {
	token: string;
	context: string;
	report_type?: string;
}

export const fetchBiTokens = async (
	context: BiTokenContext,
	value?: BiReportType
): Promise<BiTokenResponse[]> => {
	const params: any = {
		context: context,
	};

	if (value) {
		params.value = value;
	}

	const response = await api.get<BiTokenResponse[]>('/bi-tokens', { params });
	return response.data;
};

export const getUserToken = async (): Promise<string> => {
	const tokens = await fetchBiTokens(BiTokenContext.USER_TOKEN);
	return tokens[0]?.token;
};

export const getReportToken = async (value: BiReportType): Promise<string> => {
	const tokens = await fetchBiTokens(BiTokenContext.REPORT_TOKEN, value);
	return tokens[0]?.token;
};
